var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-ticker"},[_c('transition',[_c('div',{key:_vm.activeItem,staticClass:"home-ticker__item",domProps:{"textContent":_vm._s(_vm.activeItem)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }